import React from 'react';
import PropTypes from 'prop-types';
import Translate from '../Translate';

function Header({
  date = {},
  onPrevious = () => {},
  onNext = () => {},
  children = null,
}) {
  const {
    displayWeek,
    displayYear,
  } = date;
  return (
    <div className="tk-weekly-calendar__header tk-calendar__header">
      <div className="tk-calendar__title">
        <button
          type="button"
          aria-label="förra vecka"
          onClick={onPrevious}
          className="tk-calendar__button tk-calendar__button--previous"
          tabIndex={0}
        />
        <span>
          <Translate content="calendar.week" />
          {' '}
          {displayWeek}
          {' '}
          {displayYear}
        </span>
        <button
          type="button"
          aria-label="nästa vecka"
          onClick={onNext}
          className="tk-calendar__button tk-calendar__button--next"
          tabIndex={0}
        />
      </div>
      {(children)}
    </div>
  );
}

Header.propTypes = {
  date: PropTypes.shape({
    week: PropTypes.number,
    displayWeek: PropTypes.number,
    year: PropTypes.number,
    displayYear: PropTypes.number,
  }).isRequired,
  onPrevious: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default Header;
